import React from 'react';

import { Toggle } from 'components/toggle';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './ConfigStreamingToggle.scss';

const ConfigStreamingToggle = ({
  label,
  toggleId,
  checked,
  onChange,
  ...rest
}) => (
  <div className="config-streaming-toggle">
    <span className="config-streaming-toggle__title">
      <strong>
        <I18n label={label} />
      </strong>
    </span>

    <Toggle
      id={toggleId}
      name={toggleId}
      checked={checked}
      onChange={onChange}
      {...rest}
    />
  </div>
);

ConfigStreamingToggle.propTypes = {
  label: PropTypes.string.isRequired,
  toggleId: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ConfigStreamingToggle;
